import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { asPercent } from '../../../helpers';

import PerfectScrollbar from 'react-perfect-scrollbar';
import { useTheme } from '@emotion/react';
import { IconButton, TableContainer, Button, TextField } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import PanoramaFishEyeIcon from '@mui/icons-material/PanoramaFishEye';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import {
  CardActions,
  CardContent,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  TablePagination
} from '@mui/material';

import { DataGrid } from '@mui/x-data-grid';
import useClasses from '../../../helpers/useClasses';


const columns = [
  { field: 'fein', headerName: 'EIN', width: 500 },
];

const styles = theme => ({
  root: {},
  content: {
    padding: 0
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  actions: {
    justifyContent: 'flex-end'
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  processed_status_processed: {
    color: '#43a047',
    marginLeft: '20px'
  },
  success: {
    color: '#43a047'
  },
  failed: {
    color: '#C22121'
  }
});

const MerchantSubscriptionWebhookLog = props => {
  const { 
    merchant_subscription_webhooks
  } = props;
  
  const classes = useClasses(styles);

  useEffect(() => {
  }, [merchant_subscription_webhooks])

  return (
    <React.Fragment>
      <CardContent className={classes.content}>
        <PerfectScrollbar>
          <TableContainer className={classes.inner}>
          <Table>
               <TableHead>
                <TableRow>
                  <TableCell>Date</TableCell>
                  <TableCell>EIN</TableCell>
                  <TableCell>Action</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Next Retry</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {merchant_subscription_webhooks && merchant_subscription_webhooks.map(merchant_subscription_webhook => (
                  <TableRow
                    className={classes.tableRow}
                    hover
                    key={merchant_subscription_webhook.id}
                  >
                    <TableCell>
                      <div className={classes.nameContainer}>
                        <Typography variant="body1" className={merchant_subscription_webhook.status === 'failed' ? classes.failed : classes.success}>
                          {moment(merchant_subscription_webhook.created_at).format('MM/DD/YYYY HH:MM:SS')}
                        </Typography>
                      </div>
                    </TableCell>
                    <TableCell>
                      <div className={classes.nameContainer}>
                        <Typography variant="body1" className={merchant_subscription_webhook.status === 'failed' ? classes.failed : classes.success}>
                          {merchant_subscription_webhook.ein}
                        </Typography>
                      </div>
                    </TableCell>
                    <TableCell>
                      <div className={classes.nameContainer}>
                        <Typography variant="body1" className={merchant_subscription_webhook.status === 'failed' ? classes.failed : classes.success}>
                          {merchant_subscription_webhook.action}
                        </Typography>
                      </div>
                    </TableCell>
                    <TableCell>
                      <div className={classes.nameContainer}>
                        <Typography variant="body1" className={merchant_subscription_webhook.status === 'failed' ? classes.failed : classes.success}>
                          {merchant_subscription_webhook.status}
                        </Typography>
                      </div>
                    </TableCell>
                    <TableCell>
                      <div className={classes.nameContainer}>
                        <Typography variant="body1" className={merchant_subscription_webhook.status === 'failed' ? classes.failed : classes.success}>
                          {merchant_subscription_webhook.status === 'failed' ? moment(merchant_subscription_webhook.next_retry).format('MM/DD/YYYY HH:MM:SS') : ''}
                        </Typography>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </PerfectScrollbar>
      </CardContent>
    </React.Fragment>
  );
};

export default MerchantSubscriptionWebhookLog;
